<div id="congress-milestone" class="timeline-card-container">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column -->
    <div class="card-icon">
      <rds-icon namespace="outlined" icon="calendar"></rds-icon>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Title -->
      <h3 class="card-title" data-testid="congressName">{{ congress.displayName }}</h3>

      
      <!-- Milestone Type Badge -->
      <span class="milestone-type-badge" [ngClass]="milestoneTypeClass">{{ milestoneTypeLabel }}</span>
      
      <!-- Date -->
      <div class="card-meta">
        @if (formattedDate !== '—') {
          <span>{{ formattedDate }}</span>
          @if (!isDateConfirmed) {
            <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon"></rds-icon>
            <span class="estimated">Estimated</span>
          }
        } @else {
          <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon"></rds-icon>
          <span class="not-provided">Date not available</span>
        }
      </div>
      
      <!-- Location (event milestones only) -->
      @if (milestoneType === 'event') {
        <div class="card-meta">
          @if (locationText) {
            <span>{{ locationText }}</span>
          } @else {
            <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon"></rds-icon>
            <span class="not-provided">Location not available</span>
          }
        </div>
      }
      
      <!-- Expandable Detail Section -->
      @if (isExpanded) {
        <div class="congress-detail" @slideDown>
          <div class="detail-row">
            <span class="detail-label">Congress Name</span>
            <span class="detail-value">{{ congress.formalName || congress.congressName }}</span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Website</span>
            <span class="detail-value">
              @if (congress.website) {
                <a [href]="congress.website" target="_blank" rel="noopener">{{ congress.website }}</a>
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Start Date</span>
            <span class="detail-value">
              @if (congress.milestones.event.startDate) {
                {{ formatDate(congress.milestones.event.startDate) }}
                @if (!congress.milestones.event.startDateConfirmed) {
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  <span class="estimated">Estimated</span>
                }
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">End Date</span>
            <span class="detail-value">
              @if (congress.milestones.event.endDate) {
                {{ formatDate(congress.milestones.event.endDate) }}
                @if (!congress.milestones.event.endDateConfirmed) {
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  <span class="estimated">Estimated</span>
                }
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Location</span>
            <span class="detail-value">
              @if (locationText) {
                {{ locationText }}
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Abstract Deadline</span>
            <span class="detail-value">
              @if (congress.milestones.abstractDue.date) {
                {{ formatDate(congress.milestones.abstractDue.date) }}
                @if (!congress.milestones.abstractDue.confirmed) {
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  <span class="estimated">Estimated</span>
                }
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Late Breaking Abstract Deadline</span>
            <span class="detail-value">
              @if (congress.milestones.lateBreaking.date) {
                {{ formatDate(congress.milestones.lateBreaking.date) }}
                @if (!congress.milestones.lateBreaking.confirmed) {
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  <span class="estimated">Estimated</span>
                }
              } @else {
                <span class="not-provided-inline">
                  <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
                  Not available
                </span>
              }
            </span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
